// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cs-pointer[data-v-36934504] {\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
